//DO NOT CHANGE WITHOUT APPROVAL FROM FOUNDATIONS AND FRAUD
import { AxiosResponseHeaders, RawAxiosResponseHeaders } from "axios";

export const DEVICE_ID_HEADER = "X-Device-Id";
export const LOWERCASE_DEVICE_ID_HEADER = "x-device-id";
export const localStorageKey = "b2bportal-device-id";

function readFromCookie() {
  if (!globalThis.document) return undefined;
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(DEVICE_ID_HEADER))
    ?.split("=")[1];
}

function writeToCookie(deviceId: string) {
  if (!globalThis.document) return;
  document.cookie = `${DEVICE_ID_HEADER}=${deviceId}; path=/; max-age=31536000`;
}

export const getDeviceId = (): string | undefined => {
  try {
    return (
      readFromCookie() || localStorage.getItem(localStorageKey) || undefined
    );
  } catch (e) {
    console.error(e);
  }
  return undefined;
};

export const setDeviceId = (deviceId: string) => {
  try {
    writeToCookie(deviceId);
    localStorage.setItem(localStorageKey, deviceId);
  } catch (e) {
    console.error(e);
  }
};

// Save a deviceId from the response's headers if id doesn't match what's in localStorage
export const validateAndSetDeviceId = (
  headers: AxiosResponseHeaders | RawAxiosResponseHeaders
) => {
  const deviceId = getDeviceId();

  const deviceIdHeader =
    headers[LOWERCASE_DEVICE_ID_HEADER] || headers[DEVICE_ID_HEADER];

  if (deviceIdHeader && deviceId !== deviceIdHeader) {
    setDeviceId(deviceIdHeader.toString());
  }
};
